<template>
  <div class="animated fadeIn list-of-pr">
    <b-card>
      <div slot="header">List of APPROVED Purchase Request (Open/Outstand) 
        <div class="card-header-actions">
          <b-form-radio-group  v-model="tblData.viewOption">
              <b-form-radio  value="Header">View Header</b-form-radio>
              <b-form-radio  value="Lines">View Line/Items</b-form-radio>
          </b-form-radio-group>                  
          <b-button variant="btn btn-primary mr-1" @click="stop" :disabled="(tblData.viewOption=='Header')">Close/Stop the Requistion</b-button>
          <button class="btn btn-primary mr-1" @click="print()">
              <i class="fa fa-print"></i> Print
          </button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="togleFilter()">
            <i class="fa fa-filter"></i> Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
            <b-input-group >
              <b-input-group-prepend><label>Request Number</label></b-input-group-prepend>
              <b-form-input v-model="tblData.requestno" placeholder="PR No.(% for wildcard)" style="width:17% !important;"></b-form-input>
              <b-input-group-prepend><span class="p-2">Barter </span></b-input-group-prepend>
              <b-form-select v-model="tblData.barter" :plain="true" :options="dataList.barter"></b-form-select>
              <b-input-group-prepend><span class="p-2">Request by &nbsp;</span></b-input-group-prepend>
              <b-form-input v-model="tblData.createby" placeholder="Request by" style="width:22% !important;"></b-form-input>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label>MR/SR Number</label></b-input-group-prepend>
              <b-form-input v-model="tblData.mrequestno" placeholder="MR No.(% for wildcard)" ></b-form-input>
              <b-input-group-prepend><span class="p-2">Remark</span></b-input-group-prepend>
              <b-form-input v-model="tblData.remark" placeholder="PR Note/Remark" style="width:35% !important;"></b-form-input>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label>Request Date</label></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
              <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
            </b-input-group>
        </b-col>
        <b-col lg="6">
            <b-input-group >
              <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
              <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
              <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
              <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend><label>Item Requested</label></b-input-group-prepend>
              <b-form-input v-model="tblData.uraian" placeholder="Item Name/Description" style="width:30% !important;"></b-form-input>
              <b-input-group-prepend><span class="pt-2 ml-1">Category</span></b-input-group-prepend>
              <b-form-input v-model="tblData.nmcategory" placeholder="Category/Group"></b-form-input>
            </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Progress Status</label></b-input-group-prepend>
            <b-form-select v-model="tblData.pr" :plain="true" :options="dataList.prProgress"></b-form-select>
            <b-input-group-prepend><span class="pt-2">Receiving</span></b-input-group-prepend>
            <b-form-select v-model="tblData.outstand" :plain="true" :options="dataList.openStatus"></b-form-select>
            <b-input-group-append>
              <b-button class="btn btn-success ml-3" @click="search()">
                <i class="fa fa-refresh"></i> Apply Filter
              </b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()">
                <i class="fa fa-eraser"></i>Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowAttachment(data.item)" href="#"  style="padding:0 !important;">Attachment</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#" style="padding:0 !important;">Print</b-dropdown-item>
          <b-dropdown-item @click="rowStop(data.item)" href="#" style="padding:0 !important;">Close/Stop</b-dropdown-item>
        </b-dropdown>
      </template>        

        <template v-slot:cell(requestdate)="data">
          {{ data.item.requestdate | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(itemname)="data">
            <div style="width:350px;"><strong>{{data.item.itemname}}</strong> <br>
                <pre>{{data.item.description}}</pre>                
            </div>
        </template>
        <template v-slot:cell(wfcomplete)="data">
          {{ data.item.wfcomplete | moment("DD MMM YYYY hh:mm:ss") }}
        </template>
        <template v-slot:cell(quantity)="data">
          {{data.item.quantity}} &nbsp; {{data.item.unitsize}}
        </template>
        <template v-slot:cell(qtyPO)="data">
          {{data.item.qtyPO}} &nbsp; {{data.item.unitsize}}
        </template>

        <template v-slot:cell(nilai)="data">
        <span v-if="(data.item.nilai)">{{data.item.matauang}} &nbsp;{{data.item.nilai|numFormat}}</span>
        </template>
        <template v-slot:cell(jasa)="data">
          <span v-if="(data.item.jasa)">Service</span>
          <span v-else>Material</span>
        </template> 
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <input type="number" style="width:80px;" v-model="tblData.limit"/>
            </b-row>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
        <b-modal v-model="showForm" header-bg-variant="primary"  title="Close/Stop Requisition - Form" size="lg" :centered="true" @ok="handleOk" ok-title="Save">
              <b-form @submit.stop.prevent="save">
                    <b-row>
                        <b-col lg="6" xl="5">
                        <b-input-group>
                            <b-input-group-prepend><label>Request Number</label></b-input-group-prepend>
                            <b-form-input v-model="frmdata.requestno" readonly></b-form-input>
                        </b-input-group>
                        </b-col>
                        <b-col lg="6" xl="5">                            
                        <b-input-group>
                            <b-input-group-append><span class="input-group-text">Request By</span></b-input-group-append>
                            <b-form-input v-model="frmdata.createby" readonly></b-form-input>                                        
                        </b-input-group>
                        </b-col>
                    </b-row >    
                  <b-input-group>
                      <b-input-group-prepend><label>Requested Item</label></b-input-group-prepend>
                      <b-form-input readonly v-model="frmdata.itemname"></b-form-input>
                      <b-input-group-append>
                      </b-input-group-append>
                  </b-input-group>
                  <b-input-group>
                      <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                      <b-form-input v-model="frmdata.description" readonly></b-form-input>
                  </b-input-group>
                  <b-form-row>
                    <b-col lg="6">                            
                      <b-input-group>
                          <b-input-group-prepend><label>Quantity Requested</label></b-input-group-prepend>
                          <b-form-input v-model="frmdata.quantity" readonly></b-form-input>
                          <b-form-input class="ml-1" readonly v-model="frmdata.invunitom" ></b-form-input>
                      </b-input-group>
                    </b-col>
                  </b-form-row >     
                  <b-input-group>
                      <b-input-group-prepend><label>Stop/Close Reasone</label></b-input-group-prepend>
                      <b-form-textarea :rows="3" :max-rows="3" v-model="frmdata.closeReason" :state="!$v.frmdata.closeReason.$error" ></b-form-textarea>
                  </b-input-group>

              </b-form>
        </b-modal>
      <b-modal v-model="showAttachment" header-bg-variant="primary"  title="PR Attachment" size="lg" :centered="true" ok-only>
            <b-row>
                <b-col lg="6">
                    <b-input-group>
                        <b-input-group-prepend><label>Requesition(PR)No.</label></b-input-group-prepend>
                        <b-form-input v-model="model.mrequestno" readonly></b-form-input>
                    </b-input-group>
                </b-col>
            </b-row >    
            <div class="report-wraper">
              <table width="100%">
                <thead>
                  <tr>
                    <th width="200px">Attached Date</th>
                    <th >File Name</th>
                    <th width="100px">Attached By</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in attachmens" :key="row.attachmentKey">
                    <td> {{row.modified | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                    <td>                                
                        <b-link @click="attachmentDownload(row)">{{row.attchFileNm}}</b-link>
                    </td>
                    <td>{{row.createby}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

      </b-modal>
  </div>
</template>

<style lang="scss">
  .list-of-pr {
      .input-group {
          .input-group-prepend {
              label {
                  width: 110px !important;
              }
          }
      }

    pre {
        white-space: pre-wrap;       /* css-3 */
        white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
        white-space: -pre-wrap;      /* Opera 4-6 */
        white-space: -o-pre-wrap;    /* Opera 7 */
        word-wrap: break-word;       /* Internet Explorer 5.5+ */
    }    

    table {
      td:nth-child(1) {
        width: auto;
      }
      td:nth-child(2) {
        width: auto;
      }
      td {
        .dropdown-item {
            padding: 0.1rem 1.5rem !important;
            font-size: smaller !important;
        }    
      }
    }
  }
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import task from "../../apis/task";
import pr from "../../apis/logistic_pr";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required} from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { Loading},
  mixins: [validationMixin],
  validations: {
        frmdata: {
            closeReason: { required },
        },
  }, 
  data() {
    return {
      showAttachment:false,
      showFilter: false,
      showForm: false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      model:{},
      frmdata:{closeReason:''},
      tblData: {
        viewOption:'Header',
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        
        sortBy: 'requestdate',
        sortDesc: true,
        DimCol:'Dim1',outstand:'1', approved:1, pr:'0'
      },
      tblFields: [
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
          {
            key: "requestno",
            thStyle: "width:100px",
            label: "Request Number",
            sortable: true
          },
          {
            key: "requestdate",
            thStyle: "width:90px",
            label: "Request Date",
            sortable: true
          },
          {
            key: "createby",
            label: "Request By",
            sortable: true
          },
          {
            key: "wfcomplete",
            thStyle: "width:90px",
            label: "Approval Date",
            sortable: true
          },
          {
            key: "expected",
            thStyle: "width:40px",
            label: "Expected/Due",
            sortable: true
          },
          {
            key: "remark",
            label: "Remark",
            sortable: true
          },
          {
            key: "po",
            label: "P.O Number",
            sortable: true
          }          
        ],

      dataList: {
        prProgress : dropdown.prProgress ,      
        openStatus: dropdown.openClose,
        barter: dropdown.YesNoAll   
      }      
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    dimCol() {
        return this.tblData.DimCol;
    }    
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
    "tblData.viewOption" : function(newval) {
      if (newval=='Header') {
        this.tblFields=[
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
          {
            key: "requestno",
            thStyle: "width:100px",
            label: "Request Number",
            sortable: true
          },
          {
            key: "requestdate",
            thStyle: "width:90px",
            label: "Request Date",
            sortable: true
          },
          {
            key: "createby",
            label: "Request By",
            sortable: true
          },
          {
            key: "wfcomplete",
            thStyle: "width:90px",
            label: "Approval Date",
            sortable: true
          },
          {
            key: "expected",
            thStyle: "width:40px",
            label: "Expected/Due",
            sortable: true
          },
          {
            key: "remark",
            label: "Remark",
            sortable: true
          },
        ];
      } else {
        this.tblFields= [
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
          {
            key: "requestno",
            thStyle: "width:100px",
            label: "Request Number",
            sortable: true
          },
          {
            key: "requestdate",
            thStyle: "width:90px",
            label: "Request Date",
            sortable: true
          },
          {
            key: "createby",
            label: "Request By",
            sortable: true
          },
          {
            key: "wfcomplete",
            thStyle: "width:90px",
            label: "Approval Date",
            sortable: true
          },
          {
            key: "itemname",
            label: "Request Item Name & Description",
            thStyle: "width:300px",
            sortable: true
          },
          {
            key: "quantity",
            label: "Qty. Requested",
            sortable: true
          },
          {
            key: "expected",
            thStyle: "width:40px",
            label: "Expected/Due",
            sortable: true
          },
          {
            key: "qtyPO",
            label: "Qty.PO Release",
            sortable: true
          },
        ];
      }
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          this.tblFields.push(          {
            key: `${dims[i].value}Txt`,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
          this.tblFields.push({
            key: "mrequestno",
            label: "Material Request#",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          });
          this.tblFields.push({
            key: "nextwf_crewname",
            label: "Final Appover MR Dept.",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          });
        this.tblFields.push(          {
            key: "actionstatus",
            label: "Action Status",
            sortable: true
          });
        this.tblFields.push(          {
            key: "po",
            label: "P.O Number",
            sortable: true
          });

      this.refresh();
    },
  },
  created: function(){
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          this.tblFields.push(          {
            key: `${dims[i].value}Txt`,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
        this.tblFields.push({
            key: "mrequestno",
            label: "Material Request#",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          });
        this.tblFields.push({
            key: "nextwf_crewname",
            label: "Final Appover MR Dept.",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          });
        this.tblFields.push(          {
            key: "actionstatus",
            label: "Action Status",
            sortable: true
          });
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
   data: async function(ctx) {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.prlist) {
            this.tblData[key] = filter.prlist[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.prlist.tgl1 || '';
          this.tblData.tgl2=filter.prlist.tgl2 || '';
          this.showFilter=filtered;
          delete filter.prlist;
          this.$store.commit("filter", filter);
        }
      this.isLoading=true;
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      const list = await pr.list(this.tblData);
      this.items=list;
      this.isLoading=false;
     return list;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.jasa=  '';
        this.tblData.uraian=  '';
        this.tblData.requestno=  '';
        this.tblData.createby=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
        this.tblData.outstand=  '';
        this.tblData.barter=  '';
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.print();        
    },
    rowStop(record) {
      this.rowClicked(record);
        this.stop();        
    },
    rowAttachment(record) {
      this.model = record;
      this.getAttachment(record);
    },

    stop: function() {
        if (this.model.requestkey) {
            for (var key in this.model) {
                this.frmdata[key] = this.model[key];
            }

          this.showForm=true;
        } else {
            toastr.warn('Please select a row that want to be Close/Stop!');
        }
    },
    handleOk: function(evt) {
        evt.preventDefault()
        if (this.invalidModel) {
            console.log('validation : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            this.save()
        }
    },
    save: async function() {
      if (this.invalidModel) {
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            this.isLoading=true;
            try {
                await pr.closed(this.frmdata);
                this.showForm = false;
                this.refresh();
                this.isLoading=false;
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
      }
    },
    getAttachment: async function(record) {
      try {
        this.model = record;
        this.isLoading=true;
        const data = await task.getAttachment({taskkey: record.requestkey});
        this.attachmens=data;    
        this.showAttachment=true;            
        this.isLoading=false;
      } catch (error) {
        this.isLoading=false;
        console.log('error : ', error);
        if (error.sql) {
            toastr.error(error.sql,'ERROR MESSAGE',10000);
        } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
        } else if (error.message) {
            toastr.error(error.message,'ERROR MESSAGE',10000);
        } else {
            toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
        }   
      }
    },    
    attachmentDownload : async function(fl) {
        this.isLoading=true;
        try {
            const response = await task.attachmentDownload(fl);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            console.log('error : ', error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }   
        }
    },      
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    print: async function()
    {
      if (this.model.requestkey) {
          try {
                this.showReport=true;
              this.model.typePR = 'open';
              this.reportUrl= await pr.print(this.model);
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await pr.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
      router.push("/logistic/home");
    },    
  }
};
</script>
